import PropTypes from 'prop-types';
import { useEffect, useMemo } from 'react';

// material-ui
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';

// third-party
import rtlPlugin from 'stylis-plugin-rtl';

// project imports
import useConfig from 'hooks/useConfig';
import { ThemeDirection } from 'config';

export default function RTLLayout({ children }) {
  const { themeDirection } = useConfig();

  useEffect(() => {
    document.dir = themeDirection;
  }, [themeDirection]);

  const cacheRtl = useMemo(
    () =>
      createCache({
        key: themeDirection === ThemeDirection.RTL ? 'rtl' : 'css',
        prepend: true,
        stylisPlugins: themeDirection === ThemeDirection.RTL ? [rtlPlugin] : []
      }),
    [themeDirection]
  );

  return <CacheProvider value={cacheRtl}>{children}</CacheProvider>;
}

RTLLayout.propTypes = { children: PropTypes.node };
